"use strict";
/* globals module */
/**
 * @module meteringACLRoute
 * @description Baasic Metering ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering ACL Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var MeteringACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringACLRoute, _super);
    function MeteringACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'metering/data/{id}/acl/{?fields}';
        _this.updateRoute = 'metering/data/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'metering/data/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'metering/data/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get metering acl route; this URI template should be expanded with the Id of the metering.
     * @method
     * @param options ACL options object.
     * @example meteringACLRoute.get({id: '<id>'});
     **/
    MeteringACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update metering acl route; this URI template should be expanded with the Id of the metering.
     * @method
     * @param options ACL options object.
     * @example meteringACLRoute.update({id: '<id>'});
     **/
    MeteringACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser metering acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the metering.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and metering resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example meteringACLRoute.deleteByUser({
                    id: '<id>',
                    accessAction: '<access-action>',
                    user: '<username>'
                });
     **/
    MeteringACLRoute.prototype.deleteByUser = function (id, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser metering acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the metering.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and metering resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example meteringACLRoute.deleteByRole({ id: '<id>', accessAction: '<access-action>', role: '<role-name>'});
     **/
    MeteringACLRoute.prototype.deleteByRole = function (id, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    MeteringACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    MeteringACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringACLRoute);
    return MeteringACLRoute;
}(common_1.BaseRoute));
exports.MeteringACLRoute = MeteringACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
  - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
  - All end-point objects are transformed by the associated route service.
 */ 
